export default __webpack_public_path__ + "2813fdd96dd14ea4d55d6b5b3d388b04.png";